/* Up Speed cart drawer.
   Opens on [data-cart-open], intercepts PDP add-to-cart, and keeps the drawer
   and the header count in sync via Shopify's /cart AJAX API. */
(function () {
  'use strict';

  var OPEN = 'is-open';
  var lastFocus = null;

  function drawer() {
    return document.getElementById('up-cart-drawer');
  }

  function open() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    /* Compensate for the vanishing scrollbar so the page doesn't shift/reflow
       when we lock body scroll. Measure the scrollbar width and reserve it as
       padding on the body (accounting for any padding already there). */
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      var currentPad = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.paddingRight = currentPad + scrollbarWidth + 'px';
    }
    d.classList.add(OPEN);
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('up-cart-open');
    var close = d.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove(OPEN);
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('up-cart-open');
    document.body.style.paddingRight = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function isOpen() {
    var d = drawer();
    return !!d && d.classList.contains(OPEN);
  }

  /* Re-render the drawer and header count from the server so prices, discounts
     and subscription labels always come from Shopify, never from guesswork. */
  function refresh(thenOpen) {
    return fetch(window.location.pathname + '?section_id=up-cart-drawer-frag', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (html) {
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.getElementById('up-cart-drawer');
          var cur = drawer();
          if (next && cur) {
            /* Swap only the panel's contents. replaceWith() hands back an
               element without .is-open, restarting the slide transition from
               translate:100% so the panel slides out and back in. */
            var nextPanel = next.querySelector('.up-cart-panel');
            var curPanel = cur.querySelector('.up-cart-panel');
            if (nextPanel && curPanel) {
              curPanel.innerHTML = nextPanel.innerHTML;
            } else {
              var wasOpen = isOpen();
              cur.replaceWith(next);
              if (wasOpen) next.classList.add(OPEN);
            }
          }
        }
        return refreshCartPage();
      })
      .then(function () {
        return updateCount();
      })
      .then(function () {
        if (thenOpen) open();
      });
  }

  /* On /cart the line items live in the up-cart section, not the drawer, so a
     qty change has to re-render that section too or the page shows stale totals
     until a manual reload. No-op on every other template. */
  function refreshCartPage() {
    var cur = document.querySelector('[data-section="up-cart"]');
    if (!cur) return Promise.resolve();
    return fetch(window.location.pathname + '?section_id=up-cart', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-section="up-cart"]');
        var live = document.querySelector('[data-section="up-cart"]');
        if (next && live) {
          live.replaceWith(next);
          next.querySelectorAll('[data-ns-animate]').forEach(function (el) {
            el.style.opacity = '1';
          });
        }
      });
  }

  function updateCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-bubble]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.removeAttribute('hidden');
          } else {
            el.setAttribute('hidden', '');
          }
        });
        /* The button itself is hidden on mobile while the cart is empty, so the
           flag has to clear the moment something is added or it stays hidden. */
        document.querySelectorAll('.up-cart-btn').forEach(function (el) {
          if (cart.item_count > 0) {
            el.removeAttribute('data-cart-empty');
          } else {
            el.setAttribute('data-cart-empty', '');
          }
        });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () {
        return refresh(false);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) {
      e.preventDefault();
      /* Open first, then refresh behind the panel. Waiting on two round-trips
         before opening makes the drawer feel broken on a slow connection. */
      open();
      refresh(false);
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      e.preventDefault();
      changeQty(qty.getAttribute('data-cart-qty'), parseInt(qty.getAttribute('data-cart-qty-value'), 10));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  /* Intercept add-to-cart so the customer lands in the drawer instead of being
     bounced to /cart. Falls back to a normal submit if the request fails. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('disabled', '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        /* On /cart the page itself shows the cart, so opening the drawer on top
           of it is noise. Refresh in place instead. */
        if (!document.querySelector('[data-section="up-cart"]')) open();
        return refresh(false);
      })
      .catch(function () {
        form.submit();
      })
      .then(function () {
        if (btn) btn.removeAttribute('disabled');
      });
  });

  document.addEventListener('shopify:section:load', updateCount);

  /* The script is deferred, so a click on the cart icon during page load lands
     before these listeners exist. up-cart-button records that intent inline;
     honour it once we are ready. */
  if (window.__upCartWanted) {
    window.__upCartWanted = false;
    open();
    refresh(false);
  }
})();
